import React, { useState } from 'react';
import { Button, Container, Modal } from 'react-bootstrap';
import MarqueeText from './MarqueeText';
import UserFormModal from './UserFormModal';
import axios from 'axios';

const backendURL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

function ListaGrupos({ grupos = [], votar, haVotado, seccionesRefs }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedGrupo, setSelectedGrupo] = useState(null);
  const [userData, setUserData] = useState({ nombre: '', mail: '', isValid: false });

  if (!seccionesRefs.current) {
    seccionesRefs.current = {};
  }

  const estilosAgrupados = grupos.reduce((acc, grupo) => {
    acc[grupo.estilo] = acc[grupo.estilo] || [];
    acc[grupo.estilo].push(grupo);
    return acc;
  }, {});

  const handleVotarClick = (grupo) => {
    setSelectedGrupo(grupo);
    setShowModal(true);
  };

  const handleConfirmVote = async () => {
    console.log('Datos a enviar:', userData); // Verifica los datos en consola
    if (!userData.isValid) {
      console.error('Todos los campos del formulario son obligatorios y deben ser válidos.');
      return;
    }

    try {
      // Envía los datos del usuario al servidor
      await axios.post(`${backendURL}/api/users`, userData);
      // Registra el voto
      if (selectedGrupo) {
        votar(selectedGrupo._id);
      }
      setShowModal(false); // Cierra el modal
    } catch (error) {
      console.error('Error al guardar el usuario o votar:', error.response?.data || error.message);
    }
  };

  return (
    <Container>
      {Object.keys(estilosAgrupados).map((estilo) => (
        <div
          key={estilo}
          className="estilo-content"
          ref={(el) => (seccionesRefs.current[estilo] = el)}
        >
          <MarqueeText text={estilo} />
          <h2 className="text-center">{estilo}</h2>
          <ul className="list-unstyled">
            {estilosAgrupados[estilo].map((grupo) => (
              <li
                key={grupo._id}
                className="d-flex justify-content-between align-items-center border-bottom litipos"
              >
                <span>
                  <strong>{grupo.nombre}</strong>
                </span>
                <Button
                  className="votar"
                  onClick={() => handleVotarClick(grupo)}
                  disabled={haVotado}
                >
                  {haVotado ? 'Ya votaste' : 'Votar'}
                </Button>
              </li>
            ))}
          </ul>
        </div>
      ))}

      {/* Modal que contiene el formulario de usuario */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Votar por <strong>{selectedGrupo?.nombre || 'el grupo seleccionado'}</strong></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Renderiza el formulario y actualiza el estado con los datos */}
          <UserFormModal onChange={(data) => setUserData(data)} />
        </Modal.Body>
        <Modal.Footer>
          <Button className="cancelar" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button
            className="votar"
            onClick={handleConfirmVote}
            disabled={haVotado || !userData.isValid} // Deshabilitado si ya votó o el formulario no es válido
          >
            {haVotado ? 'Ya votaste' : 'Confirmar Voto'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default ListaGrupos;
